module.exports = __webpack_public_path__ + "img/ref-2.a3373a97.jpg";